const numbered = (index) => String(index + 1).padStart(2, '0');

export const safeZipPart = (value, fallback = 'Item') => String(value || fallback)
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[^a-zA-Z0-9]+/g, '_')
  .replace(/^_+|_+$/g, '')
  .slice(0, 90) || fallback;

const ASSET_NAMES = {
  instagram_feed: 'Instagram_Feed',
  instagram_story: 'Instagram_Facebook_Story',
  social_link: 'Landscape_16x9',
  phone_mockup: 'Phone_Mockup',
  onsite_qr: 'Onsite_QR_Poster_A5',
};

export const copyFilePath = (channel, index) => (
  `01_Copy/${numbered(index)}_${safeZipPart(channel.label, channel.id)}.txt`
);

export const allCopyFilePath = () => '01_Copy/00_All_Copy.md';

export const imageFilePath = (spec, index) => (
  `02_Images/${numbered(index)}_${ASSET_NAMES[spec.id] || safeZipPart(spec.label, spec.id)}_${spec.width}x${spec.height}.png`
);

export const storyFolderPath = (story, index) => (
  `03_Story_Videos/${numbered(index)}_${safeZipPart(story.title || story.stop_name, 'Story')}`
);

export const storyCopyFilePath = (story, index) => `${storyFolderPath(story, index)}/01_Text_Caption.txt`;
export const storyVideoFilePath = (story, index) => `${storyFolderPath(story, index)}/02_Video.mp4`;
export const mainPreviewVideoFilePath = () => '03_Story_Videos/00_Main_Preview/Main_Preview.mp4';
export const packageDataFilePath = () => '04_Data/Media_Package.json';

export const buildMediaPackageReadme = (packageData) => [
  packageData?.config?.guide_title || packageData?.guide?.guide_title || 'Media Package',
  '',
  'CONTENTS',
  '01_Copy          Approved communication text for each channel.',
  '02_Images        Final PNG assets, named by intended use and dimensions.',
  '03_Story_Videos  One folder per Story, containing its copy and rendered MP4.',
  '04_Data          Source Media Package data for archival or technical use.',
  '',
  'Files are numbered to preserve their intended order.',
  'If WARNINGS.txt is present, review it for assets that were unavailable during export.',
  '',
].join('\n');

export const buildAllCopy = (packageData, channels) => [
  `# ${packageData?.config?.guide_title || packageData?.guide?.guide_title || 'Media Package'}`,
  '',
  ...channels.flatMap((channel) => [
    `## ${channel.label}`,
    '',
    packageData?.drafts?.[channel.id] || '',
    '',
  ]),
].join('\n');
